import { logEvent } from './logGaEvent'

export const logExdSigninClick = () => {
  logEvent(
    'internal_link',
    {
      link_name: 'express_deal_signin',
      page_name: 'listings',
      product_name: 'air',
    },
    false
  )
}
